const PAY_IN_SCOPE = {
    FULL: 0,
    ITEMS: 1,
}

export default PAY_IN_SCOPE



// WEBPACK FOOTER //
// ./src/enums/payInScope.js